export const distributors_state = {
	distributors: {
		all: [],
		byId: {},
		taxRates: {}
	}
};
